var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("Webheader.message_list") } },
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { staticClass: "listPage overflow-hidden" },
          [
            _c(
              "b-row",
              { staticClass: "justify-content-start no-gutters" },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "btn btnFilter",
                    attrs: { disabled: _vm.activateSpinner },
                    on: {
                      click: function ($event) {
                        return _vm.onRefresh()
                      },
                    },
                  },
                  [_c("i", { staticClass: "fa-light fa-rotate-right fs-14px" })]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { md: "12" } },
                  [
                    _vm.activateSpinner
                      ? _c("spinner")
                      : _vm.items.length
                      ? _c(
                          "div",
                          [
                            _c("b-table", {
                              key: _vm.refreshList,
                              staticClass: "mt-3",
                              attrs: {
                                hover: "",
                                relative: "",
                                responsive: "",
                                fields: _vm.fields,
                                items: _vm.items,
                                selectable: "",
                                "select-mode": "single",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "cell(edit)",
                                  fn: function (data) {
                                    return [
                                      _c("i", {
                                        staticClass: "fa-regular fa-pencil",
                                        on: {
                                          click: function ($event) {
                                            return _vm.editNorm(data.item.id)
                                          },
                                        },
                                      }),
                                    ]
                                  },
                                },
                                {
                                  key: "cell(delete)",
                                  fn: function (data) {
                                    return [
                                      _c("i", {
                                        staticClass: "fa-regular fa-trash",
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteNorm(data.item.id)
                                          },
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ]),
                            }),
                          ],
                          1
                        )
                      : _c(
                          "div",
                          { staticClass: "text-center font-weight-bold" },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("common.no_result")) +
                                "\n          "
                            ),
                          ]
                        ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.canAddRTPNorm && !_vm.activateSpinner
              ? _c(
                  "b-row",
                  { staticClass: "justify-content-end mt-3 no-gutters" },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "primary" },
                        on: { click: _vm.addNorm },
                      },
                      [
                        _c("i", { staticClass: "fa-light fa-plus fs-17px" }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("common.routing.add_norm"))),
                        ]),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }